import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setGeoLoactionStateAction,
  setRegionActions,
  SetClientActions,
  setZoneActions,
  setClientBranchCreateActions,
  setClientBranchesRetrieveActions,
  SetBranchEditActions,
  setEmployeetListsActions,
  SetEmployeeDeleteActions,
  getClientBranchIds,
  getEMployeeInquriyIDS,
  getClientEditActions,
  getSideBarfilesActions,
  SetVerifiedUserActions,
  SettheExcelSheeetUpaloads,
  SetEmployeeProfileDetailsID,
  SetStatusBTN,
  SetISPendingDetails,
  getLeaveStatusPersonsListed,
  getShiftStatusPersonsListed,
  setTheShiftExcelSheetIDS,
  SettheActiveTabsActionClientDetails, ///---To---Make---Active--------------------------------
  Branch_EDIT_CLIENT_DETAILS,
  setEditableActions, ///readable
  StetheAttendanceExportActions,
  setTheUserObjects, /////--user---objects
  SetTheSuperviorsListACtions, ///superviors
  setTheSuperviorsgeteListActions, ///--add or remove
  setCreateActive,
  settheStore_filter_monthand_yeas,
  setThePageIndex,
  setTablePositionPersist
} from "../../../Redux/Slice";
import Select from "react-select";
import "../../../StyleSheet/MainComponent/ClientBranches/ClientBrachCreate.scss";
import ClientBranchCreate from "./ClientBranchCreate";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pending from "../../../Assets/AppComponent/icons/Group 145.svg";
import houseKeeping from "../../../Assets/AppComponent/icons/Role/Union.png";
import Regionicons from "../../../Assets/AppComponent/icons/Locationicons/Layer_1 .png";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import empployeeIcons from "../../../Assets/AppComponent/icons/Employee/Group 349.png";
import { useNavigate } from "react-router-dom";
import MotionPhotosAutoIcon from "@mui/icons-material/MotionPhotosAuto";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import { DateRangePicker, Header } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import SiteCreateEdit from "../SiteTransfer/SiteCreateEdit";
import AddModeratorIcon from "@mui/icons-material/AddModerator";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import Xmark from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-06.svg";

///---excel sheet download
import * as XLSX from "xlsx";
import Spreadsheet from "react-spreadsheet";
import { saveAs } from "file-saver";

////---------------Shift-------------------------------
import {
  SetShiftSearchActions,
  setShiftDeletCall,
  setShiftListsActions,
  setClientBranchActions,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import Delete from "../../AppComponent/Popup/Delete";
import ShiftCreateForm from "../../../Component/MainComponent/Shift/ShiftCreateForm";
import "../../../StyleSheet/MainComponent/Shift/Shifts.scss";
import "../../../StyleSheet/MainComponent/Client/ClientDetails.scss";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import { el, tr } from "date-fns/locale";
import { NavLink } from "react-router-dom";
import ExcelSheetUpload from "../../AppComponent/Popup/ExcelSheetUpload";
import Permission from "./Permission";
import ShiftExcelSheetG from "./ShiftExcelSheetG";
import BlackListCeatePoup from "../Blacklist/BlackListCreatePop";
import swal from "sweetalert2";
import Swal from "sweetalert2";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import ExcelFormatDwonload from "./ExcelFormatDwonload";
import ActiveEmployeeCreate from "../Active/ActiveEmployeeCreate";
import Superviors from "./Superviors";
import GridOnIcon from "@material-ui/icons/GridOn";
import ApproveEmployee from "./ApproveEmployee";
import _ from "lodash";
import ExcelSheetImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-22.svg"
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import downloadoffer from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-07.svg";

const ClientDetails = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const Swal = require("sweetalert2");
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );

  const navigate = useNavigate();
  const [ExcelSheetaLLPopup, setExcelSheetPopup] = useState(false);

  ////--------Shift-------------Excel----_Create---------------
  const [ExcelSheetpop, setExcelSheetPo] = useState(false);
  ///-------------------------Shift----Functionality
  const [dtpagesize, setdtPagesize] = useState(10);
  const [dataShift, setDatas] = useState([]);
  const [pageSize, setPageSize] = useState(20);

 const [search,setsearch] = useState(
      TablePositionPersist?.Shift_empDatas?.search == undefined ||
      TablePositionPersist?.Shift_empDatas?.search == ""
        ? ''
        : TablePositionPersist?.Shift_empDatas?.search
    );  
  

    const [currentPageShift, setCurrentPage] = useState(
        TablePositionPersist?.Shift_empDatas?.page == undefined
          ? 1
          : TablePositionPersist.Shift_empDatas.page
      );

  const [newpages, setNewpage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [DeleteID, setDeleteID] = useState("");
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [EditPopup, setEditpopup] = useState(false);
  const [EditIDSHIFT, setEditID] = useState("");
  const [ShiftSear, setSearch] = useState("");
  const [ShiftCreatePOPup, setShiftCreatePopup] = useState(false);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [shift, setShitfs] = useState([]);
  const [Counts, setCount] = useState(1);
  const ref = useRef({});
  ///----Shift-------Upload----get------------------
  const [dtpageindexShift, setdtPageindexshift] = useState(1);
  const [dtpagesizeshift, setdtPagesizeshift] = useState(10);
  const [pageSizeshift, setPageSizeshift] = useState(10);
  const [newpagesshift, setNewpageshift] = useState(1);
  const [currentPageshift, setCurrentPageshift] = useState(1);
  const [ActiveFor, setActiveFor] = useState(1); ///by based the it will move to the release or the mada as black list
  // ----------------__Site----transfer------------------
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const [createpoup, setcreatepoup] = useState(false);

  ////--Black---list---------------------------------------
  const [EmployeePop, setEmployeePopblack] = useState(false);
  const [EmployeeIDsblacklist, setEmployeeIDsblack] = useState();
  const [createblack, setcreatepoupblack] = useState(false);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  //-----Supervisor---
  const [sno, setsno] = useState(0);

  const [SuperviorsState, setSuperviorsState] = useState(false);
  ///---InActive----Create---
  const [InActiveCreatePop, setInActiveCreatePoup] = useState(false);
  const [InActiveCreateId, setInactiveCrateId] = useState("");

  ///----Employee states

  const [Employeesdata, setEmployeeDatas] = useState([]);
  const [DeletePopup, setDeletepopup] = useState(false);
  const [DeleteId, setDeleteEmployeeID] = useState();
  const [EditPopupCall, setEditPopup] = useState(false);

  const [dtpageindexemp, setdtPageindexemp] = useState(1);
  const [dtpagesizeemp, setdtPagesizeemp] = useState(10);

  const [pageSizeemp, setPageSizeemp] = useState(10);
  const [newpagesemp, setNewpageemp] = useState(1);
  const [searchemp, setsearchEmp] = useState("");
  const [Emptotalcoun, setTotallCount] = useState();
  const [EmpDAta, setEmpdatas] = useState([]);
  const [currentPageemp, setCurrentPageemp] = useState(1);

  ///---remove supervisor
  const [checked, setchecked] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [ListedIds, setlistedids] = useState([]);

  const handleHeaderCheckboxChange = (e) => {
    // console.log(ListedIds, "ListedIds", e);

    if (e) {
      setchecked(true);
      setSelectedIds(ListedIds);
    } else {
      setSelectedIds([]);
      setchecked(false);
    }
  };

  // Function to handle checkbox change
  const handleCheckboxChange = (id) => {
    // Check if the id is already in the selectedIds array
    const isSelected = selectedIds.includes(id);

    if (isSelected) {
      // If id is already selected, remove it from the array
      const updatedIds = selectedIds.filter((selectedId) => selectedId !== id);
      setSelectedIds(updatedIds);
    } else {
      // If id is not selected, add it to the array
      setSelectedIds([...selectedIds, id]);
    }

    // You can perform other actions based on the checkbox state change here
    // For example, update server data or local state
  };

  //--EXCELSHEET----UPLOAD----------------

  const [ExcelSheeTFORKYCPopup, setExcelSheetFORKYCPopup] = useState(false);
  const [getidforupload, setidforuploaddata] = useState({
    client_id: "",
    user_id: "",
  });

  const [filters, setFilters] = useState({
  month:state.NumberCounts?.Store_filter_monthand_yeas?.month ?
  state.NumberCounts?.Store_filter_monthand_yeas?.month: ""
  ,
  year: state.NumberCounts?.Store_filter_monthand_yeas?.year ?
  state.NumberCounts?.Store_filter_monthand_yeas?.year :
  ""
}); 


  const [OldEmp, setOldEMp] = useState({
    label: "CURRENT EMPLOYEE",
    value: false,
  });

  const oldemloyeeOptions = [
    {
      value: true,
      label: "OLD EMPLOYEE",
    },
    {
      value: false,
      label: "CURRENT EMPLOYEE",
    },
  ];
  const [oldemplo, setoldemp] = useState({ old_employee: false });

  //----shift---upload----download---
const ShiftUpload = [
  {
    name: "PRASANTH S",
    phone: "9150290309",
    shifts: ["B", "OFF", "A", "A", "B", "A", "A", "A", "A", "A", "A", "OFF", "A", "A", "NH", "A", "A", "A", "OFF", "A", "A", "A", "A", "A", "A", "OFF", "A", "A", "A", "A"],
  },
  {
    name: "PARTHIBAN M",
    phone: "7397249976",
    shifts: ["B", "OFF", "A", "A", "B", "A", "A", "A", "A", "A", "A", "OFF", "A", "A", "NH", "A", "A", "A", "OFF", "A", "A", "A", "A", "A", "A", "OFF", "A", "A", "A", "A"],
  },
  {
    name: "A ASHOK",
    phone: "6379860250",
    shifts: ["B", "OFF", "A", "A", "B", "A", "A", "A", "A", "A", "A", "OFF", "A", "A", "NH", "A", "A", "A", "OFF", "A", "A", "A", "A", "A", "A", "OFF", "A", "A", "A", "A"],
  },
];

const handleDownload = () => {
  if (!ShiftUpload || ShiftUpload.length === 0) {
    console.error("No data available to download");
    return;
  }

  // 🔹 Define column headers (based on your screenshot)
const headers = ["SL.NO", "NAME", "PHONE NUMBER"];
  const days = Array.from({ length: 30 }, (_, i) => (i + 1).toString());
  const sheetHeaders = [...headers, ...days];

  // 🔹 Convert your data into the required table structure
const aoaData = [sheetHeaders];

ShiftUpload.forEach((item, index) => {
  const row = [
    index + 1, // SL.NO
    item.name || "", // NAME
    item.phone || "", // PHONE NUMBER
    ...(item.shifts || Array(30).fill("")), // Days
  ];
  aoaData.push(row);
});


  try {
    // 🔹 Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet(aoaData);

    // Set column widths for better readability
    const colWidths = [
      { wch: 6 }, // SL.NO
      { wch: 18 }, // NAME
      { wch: 15 }, // PHONE NUMBER
      ...Array(30).fill({ wch: 4 }), // Days
    ];
    ws["!cols"] = colWidths;

    // 🔹 Create a new workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Shift_Schedule");

    // 🔹 Generate Excel file buffer
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // 🔹 Create Blob and trigger download
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `shift_schedule_${new Date().toISOString().split("T")[0]}.xlsx`);
    console.log("✅ Shift schedule Excel file downloaded successfully");
  } catch (error) {
    console.error("❌ Error while generating Excel file:", error);
  }
};


  const [searchSuperviorsSlice,setsearchSuperviorsSlice] = useState(
        TablePositionPersist?.Supervisor_empDatas?.search == undefined ||
        TablePositionPersist?.Supervisor_empDatas?.search == ""
          ? ''
          : TablePositionPersist?.Supervisor_empDatas?.search
      );  

  const [DeleteIDSuperviorsSlice, setDeleteIdSuperviorsSlice] = useState();
  const [DeletePopupSuperviorsSlice, setDeletePopupSuperviorsSlice] =
    useState(false);
  const [UserCreateSuperviorsSlice, setUserCreateSuperviorsSlice] =
    useState(false);
  const [UserEditPopupSuperviorsSlice, setUserEditPopupSuperviorsSlice] =
    useState(false);
  const [EditIdSuperviorsSlice, setEditIDSuperviorsSlice] = useState();
  const [dtpageindexSuperviorsSlice, setdtPageindexSuperviorsSlice] =
    useState(1);
  const [dtpagesizeSuperviorsSlice, setdtPagesizeSuperviorsSlice] =
    useState(20);
  const [pageSizeSuperviorsSlice, setPageSizeSuperviorsSlice] = useState(10);
  const [newpagesSuperviorsSlice, setNewpageSuperviorsSlice] = useState();


      const [currentPageSuperviorsSlice, setCurrentPageSuperviorsSlice] = useState(
      TablePositionPersist?.Supervisor_empDatas?.page == undefined
        ? 1
        : TablePositionPersist.Supervisor_empDatas.page
    );

  const [TypeOfsuperviors, setTypeofSupervior] = useState({
    value: "add",
    label: "added supervisor",
  });
  const [StatusRenderSuper, setStatusRenderSuper] = useState(false);
  const supervisoreOptions = [
    { value: "add", label: "added supervisor" },
    { value: "remove", label: "removed supervisor" },
  ];
  const superviorChanges = (e) => {
    setTypeofSupervior(e);
  };

  ///--Superviors-----
  useEffect(() => {
    if (state.clientDetailsCall.ActiveClinetTabs == 5) {
      const payload = {
        search: searchSuperviorsSlice,
        page_size: 20,
        // page: dtpageindexSuperviorsSlice,
        page: currentPageSuperviorsSlice,

        client_id: state.ClientBranchIDs.clientBranchEditView,
        // type: TypeOfsuperviors.value,
        type: "remove",
      };
      dispatch(SetTheSuperviorsListACtions(payload));
                            dispatch(
                  setTablePositionPersist({ data: payload, pageName: "Supervisor_empDatas" })
                );
    }
  }, [
    state.clientDetailsCall.ActiveClinetTabs,
    // TypeOfsuperviors,
    // SuperviorsState,
    // StatusRenderSuper
    // dtpageindexSuperviorsSlice,
    currentPageSuperviorsSlice ,
    searchSuperviorsSlice
  ]);

  const pageSuperviorsSlicesize = (arg) => {
    setdtPagesizeSuperviorsSlice(arg);
  };

  const pageSuperviorsSliceindex = (arg) => {
    setdtPageindexSuperviorsSlice(arg);
  };

  //---
  const handleSuperviorsSlicePrevious = (previous) => {
    if (previous != 0) {
      setCurrentPageSuperviorsSlice(previous);
    }
  };

  const GotoEnteredPageSupervisor =(gotopage)=>{
    setCurrentPageSuperviorsSlice(gotopage)
  }



  const handleSuperviorsSliceNext = (next) => {
      setCurrentPageSuperviorsSlice(next + 1);
      setNewpageSuperviorsSlice(next + 1);

    
  };

  const handlePageSuperviorsSliceChange = (page) => {
    setCurrentPageSuperviorsSlice(page);
    setNewpageSuperviorsSlice(page);
    const pageEntries = {
      search: searchSuperviorsSlice,
      // page_size: 10,
      page_size: 20,

      page: page,
      client_id: state.ClientBranchIDs.clientBranchEditView,
      // type: TypeOfsuperviors.value,
      type: "remove",
    };
    dispatch(SetTheSuperviorsListACtions(pageEntries));
  };

  const handleFirstSuperviorsSlicePage = () => {
    if (currentPageSuperviorsSlice != 1) {
      const pageEntries = {
        search: searchSuperviorsSlice,
        // page_size: dtpagesizeSuperviorsSlice,
        page_size: 20,

        page: 1,

        client_id: state.ClientBranchIDs.clientBranchEditView,
        // type: TypeOfsuperviors.value,
        type: "remove",
      };
      dispatch(SetTheSuperviorsListACtions(pageEntries));
      setCurrentPageSuperviorsSlice(1);
      setNewpageSuperviorsSlice(1);
    }
  };

  const HandleLastPageSuperviorsSlice = () => {
    if (
      currentPageSuperviorsSlice !=
      Math.ceil(state.SuperviorsSlice.Total_Count / dtpagesizeSuperviorsSlice)
    ) {
      const pageEntries = {
        search: searchSuperviorsSlice,
        // page_size: dtpagesizeSuperviorsSlice,
        page_size: 20,

        page: Math.ceil(
          state.SuperviorsSlice.Total_Count / dtpagesizeSuperviorsSlice
        ),
        client_id: state.ClientBranchIDs.clientBranchEditView,
        // type: TypeOfsuperviors.value,
        type: "remove",
      };
      dispatch(SetTheSuperviorsListACtions(pageEntries));
      setCurrentPage(
        Math.ceil(state.SuperviorsSlice.Total_Count / dtpagesizeSuperviorsSlice)
      );
      setNewpage(
        Math.ceil(state.SuperviorsSlice.Total_Count / dtpagesizeSuperviorsSlice)
      );
    }
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
            setsearchSuperviorsSlice(e);

      }, 500),
    []
  );

  function tochangeSuperviorsSlice(e) {
    setCurrentPageSuperviorsSlice(1)
    debouncedSearch(e);

    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page: 1,
    //     page_size: 10,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     // type: TypeOfsuperviors.value,
    //     type: "remove",
    //   };
    //   dispatch(SetTheSuperviorsListACtions(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleChangesOfMulti = () => {
    // Display SweetAlert with custom HTML content
    Swal.fire({
      title: "Select Options",
      html: `
        <div style="display: flex; flex-direction: row; align-items: center;    justify-content: center;
gap:20px">
        <label for="add" style="margin-bottom: 10px;">

          <input type="checkbox" id="add" name="option" value="add">
          ADD</label>
            <label for="remove" style="margin-bottom: 10px;">
          <input type="checkbox" id="remove" name="option" value="remove">
           Remove</label>

          

        </div>



      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#F05839",
      cancelButtonColor: "#F37738",
      confirmButtonText: "Yes, proceed!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Retrieve selected options
        const selectedOptions = [];
        const checkboxes = document.querySelectorAll(
          'input[name="option"]:checked'
        );

        checkboxes.forEach((checkbox) => {
          selectedOptions.push(checkbox.value);
        });

        // console.log("Selected options:", selectedOptions);

        const payload = {
          user_list: selectedIds,
          type: selectedOptions[0],
        };
        dispatch(setTheSuperviorsgeteListActions(payload));

        setSelectedIds([]);
        setchecked(false);
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "Your changes have not been applied.",
          showConfirmButton: false,
          timer: 1000, // Close the modal after 2 seconds (2000 milliseconds)
        });
      }
    });
  };
  ///---handel the removed supervisor
  const HandleTheRemovedSupervior = (e) => {
      setsearchSuperviorsSlice("");
    setdtPageindexSuperviorsSlice(1);
              const Supervisour_status = { 
          search: "",
        page_size: 20,
        // page: state.NeededdatasListed.PageIndex,
        page: 1,

 };
            const result_Supervisourlist = { ...TablePositionPersist.Supervisor_empDatas, ...Supervisour_status };
            dispatch(
              setTablePositionPersist({
                data: result_Supervisourlist,
                pageName: "Supervisor_empDatas",
              })
            ); 


    const payload = {
      data: {
        user_list: [e],
        type: "remove",
      },
      page: 1,
      search: "",
      client_id: state.ClientBranchIDs.clientBranchEditView,

    };
    dispatch(setTheSuperviorsgeteListActions(payload));
    setStatusRenderSuper(!StatusRenderSuper);
  };
  // const columnSuperviorss = [
  //   // {
  //   //   id: "checkboxColumn", // Unique ID for the column
  //   //   Header: (
  //   //     <input
  //   //       type="checkbox"
  //   //       id={`checkbox1`}
  //   //       className="custom-checkbox1"
  //   //       onChange={(e) => {
  //   //         handleHeaderCheckboxChange(e.target.checked);
  //   //       }}
  //   //       checked={checked}
  //   //     />
  //   //   ),
  //   //   accessor: "", // This accessor might need to be updated based on your data structure
  //   //   Cell: (row) => {
  //   //     return (
  //   //       <>
  //   //         {row.row.original.user_id &&
  //   //         row.row.original.user_id.first_name &&
  //   //         row.row.original.id != null ? (
  //   //           <input
  //   //             style={{ marginRight: "10px" }}
  //   //             type="checkbox"
  //   //             id={`checkbox-${row.row.original.id}`}
  //   //             className="custom-checkbox1"
  //   //             onChange={() => {
  //   //               handleCheckboxChange(row.row.original.id);
  //   //             }}
  //   //             checked={selectedIds.includes(row.row.original.id)}
  //   //           />
  //   //         ) : (
  //   //           <span>---</span>
  //   //         )}
  //   //       </>
  //   //     );
  //   //   },
  //   // },

  //   {
  //     Header: "Tnx Id",
  //     accessor: "",
  //     Cell: ({ row }) => row.index + 1, // Section number based on row index
  //   },

  //   {
  //     Header: " Name",
  //     accessor: "",
  //     Cell: (row) => {
  //       //   console.log(row.row.original, "sdflsd");
  //       return (
  //         <>
  //           <div className="UserName" style={{ cursor: "pointer" }}>
  //             {/* {row.row.original.user_id != undefined &&
  //             row.row.original.user_id != null &&
  //             row.row.original.user_id.user_image != undefined &&
  //             row.row.original.user_id.user_image != null &&
  //             row.row.original.user_id.user_image.media_url != undefined &&
  //             row.row.original.user_id.user_image.media_url != null ? (
  //               <div className="ProfilImg">
  //                 <img src={row.row.original.user_id.user_image.media_url} />
  //               </div>
  //             ) : (
  //               <div className="ProfilImg">
  //                 <img src={profile2} />
  //               </div>
  //             )} */}
  //             <div className="">
  //               <span>
  //                 {row.row.original.user_id.first_name}

  //                 {row.row.original.user_id &&
  //                 row.row.original.user_id.first_name &&
  //                 row.row.original.id != null ? (
  //                   // <input
  //                   //   style={{ marginRight: "10px" }}
  //                   //   type="checkbox"
  //                   //   id={`checkbox-${row.row.original.id}`}
  //                   //   className="custom-checkbox1"
  //                   //   onChange={() => {
  //                   //     handleCheckboxChange(row.row.original.id);
  //                   //   }}
  //                   //   checked={selectedIds.includes(row.row.original.id)}
  //                   // />
  //                   <button
  //                     style={{
  //                       background: "#d8e2fb",
  //                       borderRadius: "50%",
  //                       padding: "1px",
  //                       marginLeft: "12px",
  //                       width: "29px",
  //                     }}
  //                     data-tooltip-id="Name-ToolTips"
  //                     data-tooltip-content="Remove Supervisor"
  //                     onClick={(e) => {
  //                       HandleTheRemovedSupervior(row.row.original.id);
  //                     }}
  //                   >
  //                     <i class="fa-solid fa-xmark" style={{ color: "red" }}></i>
  //                   </button>
  //                 ) : (
  //                   <span>---</span>
  //                 )}
  //               </span>
  //             </div>
  //           </div>
  //         </>
  //       );
  //     },
  //   },

  //   {
  //     Header: "Email",
  //     accessor: "",
  //     Cell: (row) => {
  //       return (
  //         <>
  //           {row.row.original.user_id.email != undefined &&
  //           row.row.original.user_id.email != null ? (
  //             <span>{row.row.original.user_id.email}</span>
  //           ) : (
  //             <span>{"--"}</span>
  //           )}
  //         </>
  //       );
  //     },
  //   },

  //   {
  //     Header: "Role",
  //     accessor: "",
  //     Cell: (row) => {
  //       return (
  //         <>
  //           {row.row.original.user_id.user_role != undefined &&
  //           row.row.original.user_id.user_role.role != undefined ? (
  //             <span>{row.row.original.user_id.user_role.role}</span>
  //           ) : (
  //             <span>{"--"}</span>
  //           )}
  //         </>
  //       );
  //     },
  //   },

  //   {
  //     Header: "Created Date",
  //     accessor: "",
  //     Cell: (row) => {
  //       const dateString = row.row.original.created_at;
  //       const dateObject = new Date(dateString);
  //       const hours = dateObject.getHours();
  //       const minutes = dateObject.getMinutes();
  //       const seconds = dateObject.getSeconds();
  //       const amOrPm = hours >= 12 ? "PM" : "AM";
  //       const twelveHourFormat = hours % 12 || 12;
  //       const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  //       const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
  //       return (
  //         <>
  //           <p
  //             data-tooltip-id="my-tooltip"
  //             data-tooltip-content={`${formattedTime}`}
  //           >
  //             {row.row.original.created_at != undefined &&
  //             row.row.original.created_at != null
  //               ? `${
  //                   row.row.original.created_at.slice(0, 10) +
  //                   "  " +
  //                   formattedTime
  //                 }`
  //               : "---"}
  //           </p>
  //         </>
  //       );
  //     },
  //   },

  //   // {
  //   //   Header: "Actions",
  //   //   accessor: "",
  //   //   Cell: (row) => {
  //   //     return (
  //   //       <>
  //   //         <div
  //   //           class="actions"
  //   //           style={{
  //   //             display: "flex",
  //   //             justifyContent: "flex-start",
  //   //             gap: "5px",
  //   //           }}
  //   //         >
  //   //           <button
  //   //             className=" btn Status"
  //   //             component="span"
  //   //             // onClick={(e) => {
  //   //             //   setEditIds(row.row.original.id);
  //   //             //   setopenPerformance(!openperformance);
  //   //             // }}
  //   //           >
  //   //             {" "}
  //   //             <span>
  //   //               {" "}
  //   //               <i
  //   //                 class="fa-solid fa-pen"
  //   //                 style={{ fontSize: "13px", paddingRight: "3px" }}
  //   //               ></i>
  //   //               Edit{" "}
  //   //             </span>
  //   //           </button>
  //   //         </div>
  //   //       </>
  //   //     );
  //   //   },
  //   // },
  // ];
  const columnSuperviorss = useMemo(
    () => [
 {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (
            row.row.original.id != undefined &&
            row.row.original.id != null
          ) {
            const userId = row.row.original.id;
            const lastFourDigits = userId.slice(-6);
            return <p className="m-0">{lastFourDigits}</p>;
          }
        },
      },
//             {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
  {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
      {
        Header: " Name",
        accessor: "",
        Cell: (row) => {
          //   console.log(row.row.original, "sdflsd");
          return (
            <>
              <div className="UserName" style={{ cursor: "pointer" }}>
                <div className="">
                  <span>{row.row.original.user_id.first_name}</span>
                </div>
              </div>
            </>
          );
        },
      },

      {
        Header: "Email",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.user_id.email != undefined &&
              row.row.original.user_id.email != null ? (
                <span>{row.row.original.user_id.email}</span>
              ) : (
                <span>{"--"}</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Role",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.user_id.user_role != undefined &&
              row.row.original.user_id.user_role.role != undefined ? (
                <span>{row.row.original.user_id.user_role.role}</span>
              ) : (
                <span>{"--"}</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;
          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <span>
                {row.row.original.created_at != undefined &&
                row.row.original.created_at != null
                  ? `${
                      row.row.original.created_at.slice(0, 10) +
                      "  " +
                      formattedTime
                    }`
                  : "---"}
              </span>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          const [showTooltip, setShowTooltip] = useState(false);

          return (
            <>
              <div
                class="actions"
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "5px",
                }}
              >
                {row.row.original.user_id &&
                row.row.original.user_id != undefined &&
                row.row.original.user_id != null &&
                row.row.original.user_id.id !=""
                &&
                row.row.original.user_id.id != undefined &&
                row.row.original.user_id.id != null &&
                row.row.original.user_id.first_name &&
                row.row.original.id != null ? (
                  <button
                    style={{
                      background: "#d8e2fb",
                      borderRadius: "50%",
                      padding: "1px",
                      marginLeft: "12px",
                      width: "32px",
                      zIndex: "0",
                      position: 'relative',
                      display:"flex",
                      justifyContent:"center",
                      alignItems:"center",
                      outline:"none"
                    }}

                    onClick={(e) => {
                      HandleTheRemovedSupervior(row.row.original.user_id.id);
                    }}
                    onMouseEnter={() => setShowTooltip(true)} 
                    onMouseLeave={() => setShowTooltip(false)}
        
                  >
                    <span  className="EditImages" style={{width:"16px",height:"23px"}}>
                    <img src={Xmark}/>
                    </span>
                    {showTooltip && (
              <div className="custom-tooltip-branch">
                {"Remove Supervisor"}
              </div>
            )}

                  </button>
                ) : (
                  <span>---</span>
                )}
              </div>
            </>
          );
        },
      },
    ],
    [sno]
  );

  //   const [selectedDates, setSelectedDates] = useState();
  //   var today = new Date();
  //   var prioiDate = new Date(new Date().setDate(today.getDate() - 30));
  //   // console.log(String(today) );
  //   var it = String(today);
  //   var gt = String(prioiDate);
  //   // console.log(it, gt);
  //   const [range, setrange] = useState([gt, it]);
  // const getCurrentAndNextMonthDates = () => {
  //   const currentDate = new Date();
  //   const currentMonth = currentDate.getMonth() + 1;
  //   const currentYear = currentDate.getFullYear();
  //   const currentdate = currentDate.getDate()
  //   const nextMonthDate = new Date(currentYear, currentMonth);
  //   nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //   const currentMonthFormatted = `${currentYear}-${String(currentMonth).padStart(2, '0')}-${currentdate}`;
  //   const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(nextMonthDate.getMonth() + 1).padStart(2, '0')}-${}`;

  //   return { currentMonth: currentMonthFormatted, nextMonth: nextMonthFormatted };
  // }

  //   const getCurrentAndNextMonthDates = () => {
  //     const currentDate = new Date();
  //     const currentMonth = currentDate.getMonth() + 1;
  //     const currentYear = currentDate.getFullYear();
  //     const currentdate = currentDate.getDate()
  //     const nextMonthDate = new Date(currentYear, currentMonth);
  //     nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //     const currentMonthFormatted = `${currentYear}-${String(currentMonth).padStart(2, '0')}-${currentdate}`;

  //     // Get the last date of the next month
  //     const nextMonthLastDate = new Date(nextMonthDate.getFullYear(), nextMonthDate.getMonth() , 0);
  //     const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(nextMonthDate.getMonth() + 1).padStart(2, '0')}-${nextMonthLastDate.getDate()}`;

  //     return { currentMonth: currentMonthFormatted, nextMonth: nextMonthFormatted };
  // }

  // const getCurrentAndNextMonthDates = () => {
  //   const currentDate = new Date();
  //   const currentMonth = currentDate.getMonth() + 1;
  //   const currentYear = currentDate.getFullYear();
  //   const currentdate = currentDate.getDate();

  //   const nextMonthDate = new Date(currentYear, currentMonth - 1); // Subtract 1 from currentMonth
  //   nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //   const currentMonthFormatted = `${currentYear}-${String(
  //     currentMonth
  //   ).padStart(2, "0")}-${currentdate}`;

  //   // Get the last date of the next month
  //   const nextMonthLastDate = new Date(
  //     nextMonthDate.getFullYear(),
  //     nextMonthDate.getMonth() + 1,
  //     0
  //   );
  //   const nextMonthFormatted = `${nextMonthDate.getFullYear()}-${String(
  //     nextMonthDate.getMonth() + 1
  //   ).padStart(2, "0")}-${nextMonthLastDate.getDate()}`;

  //   return {
  //     currentMonth: currentMonthFormatted,
  //     nextMonth: nextMonthFormatted,
  //   };
  // };

  // // Usage
  // var { currentMonth, nextMonth } = getCurrentAndNextMonthDates();

  const getCurrentMonthStartAndEndDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const firstDateOfMonth = new Date(currentYear, currentMonth - 1, 1);
    const lastDateOfMonth = new Date(currentYear, currentMonth, 0);

    const startDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(firstDateOfMonth.getDate()).padStart(2, "0")}`;
    const endDatemon = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${String(lastDateOfMonth.getDate()).padStart(2, "0")}`;

    return {
      startDatemon,
      endDatemon,
    };
  };

  var { startDatemon, endDatemon } = getCurrentMonthStartAndEndDate();

  const [data, setdata] = useState({
    from_date: startDatemon,
    to_date: endDatemon,
    range: false,
    base_type: "day",
  });

  const Options = [
    {
      id: 1,
      value: "day",
      label: "DAY",
    },
    {
      id: 2,
      value: "time",
      label: "TIME",
    },
  ];

  const HandleChanges = (e) => {
    //    console.log(e.target.value, "sdfsdgfweifi");

    setdata({ ...data, base_type: e.target.value });
  };

  //   //----Handle----Date=-----Changes---
  //   const handlechangedate = (value, d) => {
  //     console.log(value , d , "values");
  //     if (value != null) {
  //       setrange((oldArray) => [...oldArray, d.slice(0, 10)]);

  //       setdata((prevData) => ({
  //         ...prevData,
  //         [value]: d.slice(0, 10), // Update the 'from_date' or 'to_date' property
  //       }));
  //     }
  //     console.log(range, "range", data);
  // };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);

  // const handleDatesChange = ({ startDate, endDate }) => {
  //   setStartDate(startDate);
  //   setEndDate(endDate);
  // };

  const [selectedDates, setSelectedDates] = useState([]);
  const [datestae, setdatest] = useState(false);
  const formattedDates =
    selectedDates != null &&
    selectedDates.map((date) => {
      const isoString = date.toISOString();
      return isoString.substring(0, 10);
    });

  const handleDateChange = (e) => {
    if (e != null) {
      setdatest(true);
      setSelectedDates(e);
      e.forEach((newValue) => {
        const tzoffset = new Date().getTimezoneOffset() * 60000;
        const localISOTime = new Date(newValue - tzoffset)
          .toISOString()
          .slice(0, -1);
        // handle the start and end dates here
      });
    }
  };

  useEffect(() => {
    if (datestae) {
      setdata({
        ...data,
        from_date: formattedDates[0],
        to_date: formattedDates[1],
        range: true,
      });
    }
  }, [selectedDates]);

  const handleFocusChange = (focusedInput) => {
    setFocusedInput(focusedInput);
  };

  // const [yearAndMonth, setYearMpnth] = useState();
  // const date = new Date();
  // console.log(date.getFullYear(), "date");
  // const months =
  //   date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth();
  // console.log(yearAndMonth, "yearAndMonth");
  // //var yearAndMonth = `${date.getFullYear()}-${months}`;
  // useEffect(() => {
  //   setYearMpnth(`${date.getFullYear()}-${months}`);
  // }, []);

  // //  console.log(state.AttendanceexportCall.AttendanceListExportDatas ,"AttendanceexportCall");
  // const [monthYearset, setMonthYear] = useState("");

  const handleChange = (e) => {
    /// setMonthYear(e.target.value);
    //   const months = new Date(e.target.value);
    //   // months.getMonth()
    //   console.log(months.getMonth() + 1, "months", months.getFullYear());
    //   const selectedmonth =
    //     months.getMonth() < 10
    //       ? `0${months.getMonth() + 1}`
    //       : months.getMonth() + 1;
    //   setYearMpnth(`${months.getFullYear()}-${selectedmonth}`);
    //   console.log(e.target.value, "weurweydsfsd", selectedmonth);
    //   setdata({
    //     ...data,
    //     month: selectedmonth,
    //     year: months.getFullYear(),
    //   });
    // };
  };

  ///--attendance--export------------------
  // useEffect(()=>{
  //   const payloads = {
  //     export_type:"client",
  //     client_id: state.ClientBranchIDs.clientBranchEditView,

  //   };
  //    dispatch(StetheAttendanceExportActions(payloads))
  // },[])

  //console.log(state.AttendanceexportCall ,"AttendanceexportCall");
  useEffect(() => {
    if (
      state.ClientBranchIDs.clientBranchEditView != undefined &&
      state.clientDetailsCall.ActiveClinetTabs == 1
    ) {
      const payloads = {
        search: search,
        page_size: 20,
        page: currentPageShift,
        client_id: state.ClientBranchIDs.clientBranchEditView,
        // client_id: state.ClientBranchIDs.ClientBranchID,
      };

      // dispatch(SetShiftSearchActions(payloads));
      dispatch(SetShiftSearchActions(payloads));
                dispatch(
                  setTablePositionPersist({ data: payloads, pageName: "Shift_empDatas" })
                );
      // console.log(payloads, "ClientBranchShifts");
      // console.log(
      //   state.ShiftList.ShiftLists,
      //   "states",
      //   state.ShiftList.Total_Count
      // );
      // setDatas(state.ShiftList.ShiftLists);
      setShitfs(state.ShiftSearch.ShiftSearch);
      //  console.log(state.ClientBranchIDs.clientBranchEditView, "idfd");
    }
    // console.log(
    // state.BranchRetrieve.BranchesRetrieve.id,
    // "CLientsss Branch IDS",
    // state.ShiftSearch.ShiftSearch
    // );
  }, [state.clientDetailsCall.ActiveClinetTabs , search]);

  useEffect(() => {
    if (state.ClientBranchIDs.clientBranchEditView != undefined) {
      setShitfs(state.ShiftSearch.ShiftSearch);
      // console.log(
      //   state.ShiftSearch.ShiftSearch,
      //   "SHiftSearchedONE",
      //   state.ClientBranchIDs
      // );
    }
  }, []);

 
  const handlePrevious = (previous) => {
    if (previous != 0) {
      setCurrentPage(previous);
      
    }
  };
  const handleNext = (next) => {
      setCurrentPage(next + 1);

    
  };

  const GotoEnteredPage =(gotopage)=>{
    setCurrentPage(gotopage)
  }

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const debouncedshift = useMemo(
    () =>
      _.debounce((e) => {
setsearch(e)
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1)
    debouncedshift(e);
    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesize,
    //     page: 1,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //   };
    //   dispatch(SetShiftSearchActions(payload));
    //   //  dispatch(SetShiftSearchActions(payload));
    // }
    // if (e == "" || search == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesize,
    //     page: 1,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //   };
    //   //dispatch(SetShiftSearchActions(payload));
    //   dispatch(SetShiftSearchActions(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedshift.cancel();
    };
  }, [debouncedshift]);

  const handlePageChange = (newPage) => {
    if (newPage < state.ShiftList.Total_Count) {
      setCurrentPage(newpages + 1);

      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        // page_size: 10,
        page_size: 20,

        page: newPage,
        client_id: state.ClientBranchIDs.clientBranchEditView,
      };
      // dispatch(SetShiftSearchActions(pageEntries));
      dispatch(SetShiftSearchActions(pageEntries));
    }
  };

  const HandelDelete = () => {
    setsearch("");
    setdtPageindex(1)
    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        currentPageShift: 1,
        client_id: state.ClientBranchIDs.clientBranchEditView,
      };
      dispatch(setShiftDeletCall(payload, setDeletePOPUP(false)));
    }
  };

  const truncate = (text, limit = 15) => {
  if (!text) return "---";
  return text.length > limit ? text.slice(0, limit) + "..." : text;
};



  const columns = [
{
  Header: "Shift",
  accessor: "shift_name",
  Cell: ({ row }) => {
    const shiftname = row.original.shift_name;
    return <span>{truncate(shiftname, 15)}</span>;
  }
},
{
  Header: "Excel Code",
  accessor: "excel_code",
  Cell: ({ row }) => {
    const excel = row.original.excel_code;
    return <span>{truncate(excel, 15)}</span>;
  }
},
    {
      Header: "Start Time ",
      accessor: "from_time ",
      Cell: (row) => {
        return (
          <>
            <div className="Create-Date">
              <div
                style={{ marginTop: "3px" }}
              >
                <span> {String(row.row.original.from_time)} </span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: "End Time ",
      accessor: "end_time ",
      Cell: (row) => {
        return (
          <>
            <div className="Create-Date">
              <div
                style={{ marginTop: "3px" }}
              >

                <span> {String(row.row.original.end_time)} </span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: "Total Manpower",
      accessor: "total_manpower",
      Cell: ({ row }) => {
        const manpower = row.original.total_manpower;
        return <span>{manpower ? manpower : "Not set"}</span>;
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <div className="CreatedDatelisted"
            >
              {`${
                row.row.original.created_at.slice(0, 10) }`}
            </div>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                component="span"
                onClick={(e) => {
                  setEditID(row.row.original.id);
                  setEditpopup(true);
                }}
              >
                <span className="OuterActionSpan">
             
                     <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

{state.ClientBranchIDs.SUBROLE == 3? 
              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">

                  <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>
                  
                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
              :null}
            </div>
          </>
        );
      },
    },
  ];

  ////--------------------------Emp Inquriy----------FUnctionality
  const [dtpageindexEMp, setdtPageindexEMP] = useState(1);
  const [dtpagesizeEmp, setdtPagesizeEMp] = useState(10);
  const [pageSizeEMP, setPageSizeEMp] = useState(10);
  const [searchEmp, setsearchEMP] = useState("");
  const [newpagesEmp, setNewpageEMP] = useState(1);
  const [currentPageEmp, setcurrentPageemp] = useState(1);

  const [DeleteIDEMP, SetDeleteEmpID] = useState("");
  const [DeleteEmpPOPUP, setDeletePOPUPEMp] = useState(false);
  const [EditIdEmp, setEditId] = useState("");
  const [EditPopupEmp, setsetEditEmpPOPUP] = useState(false);
  const [EmpCreatepopup, setCreateEmpPopup] = useState(false);
  const [MakeCreateEmp, setCreateBarStatus] = useState(true);

  // useEffect(() => {
  // if (state.ClientBranchIDs.clientBranchEditView != undefined) {
  // const payloads = {
  // search: "",
  // page_size: dtpagesizeEmp,
  // page: currentPageEmp,
  // client_id: state.ClientBranchIDs.clientBranchEditView,
  // };
  // dispatch(setEmployeetListsActions(payloads));
  // console.log(
  // state.EmployeeListsdata.EmployeeLists.client_id,
  // "employee",
  // state.EmployeeListsdata.Total_Count,
  // state.EmployeeListsdata.EmployeeLists.client_id
  // );
  // setEmpdatas(state.EmployeeListsdata.EmployeeLists);
  // }
  // }, []);

  // const handleFirstPageEMP = () => {
  // if (
  // currentPageEmp != 1 &&
  // state.ClientBranchIDs.clientBranchEditView != ""
  // ) {
  // const pageEntries = {
  // search: searchEmp,
  // page_size: dtpagesizeEmp,
  // page: 1,
  // client_id: state.ClientBranchIDs.clientBranchEditView,
  // };
  // dispatch(setEmployeetListsActions(pageEntries));
  // setcurrentPageemp(1);
  // setNewpageEMP(1);
  // }
  // };
  // const HandleLastPageEMP = () => {
  // if (
  // state.ClientBranchIDs.clientBranchEditView != "" &&
  // currentPageEmp !=
  // Math.ceil(state.EmployeeListsdata.Total_Count / dtpagesizeEmp)
  // ) {
  // const pageEntries = {
  // search: searchEmp,
  // page_size: dtpagesizeEmp,
  // page: Math.ceil(state.EmployeeListsdata.Total_Count / dtpagesizeEmp),
  // client_id: state.ClientBranchIDs.clientBranchEditView,
  // };
  // dispatch(setEmployeetListsActions(pageEntries));
  // setcurrentPageemp(
  // Math.ceil(state.EmployeeListsdata.Total_Count / dtpagesizeEmp)
  // );
  // setNewpageEMP(
  // Math.ceil(state.EmployeeListsdata.Total_Count / dtpagesizeEmp)
  // );
  // }
  // };
  // const handlePreviousEmp = (previous) => {
  // console.log(previous, "previous");
  // if (state.ClientBranchIDs.clientBranchEditView != "" && previous != 0) {
  // setcurrentPageemp(previous);
  // const pageEntries = {
  // search: searchEmp,
  // page_size: dtpagesizeEmp,
  // page: previous,
  // client_id: state.ClientBranchIDs.clientBranchEditView,
  // };
  // dispatch(setEmployeetListsActions(pageEntries));
  // }
  // };
  // const handleNextEmp = (next) => {
  // console.log(
  // next,
  // "next one",
  // Math.ceil(state.EmployeeListsdata.Total_Count / dtpagesizeEmp)
  // );
  // if (
  // next != Math.ceil(state.EmployeeListsdata.Total_Count / dtpagesizeEmp)
  // ) {
  // if (next < state.VerifiedUsers.Total_Count){
  // setcurrentPageemp(next + 1);
  // console.log(newpagesEmp, "newpagess");
  // setNewpageEMP(next + 1);
  // const pageEntries = {
  // search: searchEmp,
  // page_size: dtpagesizeEmp,
  // page: next + 1,
  // client_id: state.ClientBranchIDs.clientBranchEditView,
  // };
  // dispatch(setEmployeetListsActions(pageEntries));

  // console.log("New Page:", pageEntries);
  // }
  // };
  // const pagesizeEMP = (arg) => {
  // setdtPagesizeEMp(arg);
  // };

  // const pageindexEMP = (arg) => {
  // console.log(arg, "args");
  // setdtPageindexEMP(arg);
  // };

  //-----Search- EMP-----------------------
  // function toEmpSearch(e) {
  // console.log("ee", e);
  // setsearchEMP(e);

  // if (
  // state.ClientBranchIDs.clientBranchEditView != "" &&
  // e != undefined &&
  // e !== ""
  // ) {
  // const payload = {
  // search: e,
  // page_size: dtpagesizeEmp,
  // page: 1,
  // client_id: state.ClientBranchIDs.clientBranchEditView,
  // };
  // console.log(e, "testnew")
  // dispatch(setEmployeetListsActions(payload));
  // }
  // if (state.ClientBranchIDs.clientBranchEditView != "" && searchEmp == "") {
  // const payload = {
  // search: "",
  // page_size: dtpagesizeEmp,
  // page: 1,
  // client_id: state.ClientBranchIDs.clientBranchEditView,
  // };
  // dispatch(setEmployeetListsActions(payload));
  // }
  // }

  // const handlePageChangeEMP = (newPage) => {
  // if (
  // state.ClientBranchIDs.clientBranchEditView != "" &&
  // newPage < state.EmployeeListsdata.Total_Count
  // ) {
  // setcurrentPageemp(newpagesEmp + 1);
  // console.log(newpagesEmp, "newpagess");
  // setNewpageEMP(newPage + 1);
  // const pageEntries = {
  // search: searchEmp,
  // page_size: 10,
  // page: newPage,
  // client_id: state.ClientBranchIDs.clientBranchEditView,
  // };
  // dispatch(setEmployeetListsActions(pageEntries));
  // console.log("New Page:", newpagesEmp);
  // }
  // };

  // const HandleEmpDelete = () => {
  // if (
  // state.ClientBranchIDs.clientBranchEditView != "" &&
  // DeleteIDEMP != undefined
  // ) {
  // console.log(currentPageEmp, "sdsd");
  // const payload = {
  // DeleteID: DeleteIDEMP,
  // currentPage: currentPageEmp,
  // client_id: state.ClientBranchIDs.clientBranchEditView,
  // };
  // dispatch(SetEmployeeDeleteActions(payload, setDeletePOPUPEMp(false)));
  // }
  // };

  // const columnsEMp = [
  // {
  // Header: "Client",
  // accessor: "",
  // Cell: (row) => {
  // return (
  // <>
  {
    /* <span>{row.row.original.client_id.client_name}</span> */
  }
  {
    /* </> */
  }
  // );
  // },
  // },
  // {
  // Header: "Role",
  // accessor: "",
  // Cell: (row) => {
  // return (
  // <>
  {
    /* <span>{row.row.original.role_id.role}</span> */
  }
  {
    /* </> */
  }
  // );
  // },
  // },

  // {
  //     Header: "Shift",
  //     accessor: "",
  //     Cell: (row) => {

  //         return (
  //             <>
  //                 <span>{row.row.original.shift_id.shift_name}</span>
  //             </>
  //         )
  //     }
  // },

  // {
  // Header: "Actions",
  // accessor: "",
  // Cell: (row) => {
  // return (
  // <>
  {
    /* <div */
  }
  // class="actions"
  // style={{
  // display: "flex",
  // justifyContent: "flex-start",
  // gap: "5px",
  // }}
  // >
  {
    /* <button */
  }
  // className=" btn Status"
  // component="span"
  // onClick={(e) => {
  // EDITCallFunctions(row.row.original.id);
  /// setsetEditEmpPOPUP(true);
  // setEditId(row.row.original.id);
  // }}
  // >
  {
    /* {" "} */
  }
  {
    /* <span> */
  }
  {
    /* {" "} */
  }
  {
    /* <i */
  }
  // class="fa-solid fa-pen"
  // stysetCreateEmpPopuple={{
  // fontSize: "13px",

  // paddingRight: "7px",
  // }}
  // ></i>
  {
    /* Edit{" "} */
  }
  {
    /* </span> */
  }
  {
    /* </button> */
  }

  {
    /* <button */
  }
  // type="button"
  // class="btn Status"
  // onClick={(e) => {
  // SetDeleteEmpID(row.row.original.id);
  // setDeletePOPUPEMp(true);
  // }}
  // >
  {
    /* <span> */
  }
  {
    /* {" "} */
  }
  {
    /* <i */
  }
  // class="fa-regular fa-trash-can"
  // style={{
  // fontSize: "15px",
  // paddingRight: "3px",
  // paddingBottom: "3px",
  // }}
  // ></i>
  {
    /* Delete{" "} */
  }
  {
    /* </span> */
  }
  {
    /* </button> */
  }
  {
    /* </div> */
  }
  {
    /* </> */
  }
  // );
  // },
  // },
  // ];

  ///---Route---CLient----Branch---Hold---client--id
  // const RouteHoldClient = () => {
  // if (state.ClientBranchIDs.clientBranchEditView != "") {
  // dispatch(getClientBranchIds(state.ClientBranchIDs.clientBranchEditView));
  // window.location.href = "/employeedetails";
  // setEditId("");
  // dispatch(getEMployeeInquriyIDS(""));
  // console.log(state.ClientBranchIDs.EmployeeIDs, "edalksdnl");
  // }
  // };

  ///---Handle----the Edit---Dispatch----Calls
  // const EDITCallFunctions = (e) => {
  // dispatch(getEMployeeInquriyIDS(e));
  // console.log(state.ClientBranchIDs.EmployeeIDs, "EDITSSSSS", e);
  // window.location.href = "/employeedetails";
  // };

  ///-----Client---Branch---Edit
  const [BranchEditid, setEditBranchID] = useState("");
  const [EditBranchPOPUP, setEditPopupBranch] = useState(false);
  useEffect(() => {
    if (state.ClientBranchIDs.clientBranchEditView != undefined) {
      setEditBranchID(state.ClientBranchIDs.clientBranchEditView);
      // console.log(
      // EditBranchPOPUP,
      // "test",
      // state.ClientBranchIDs.clientBranchEditView
      // );
    }
  }, [state.ClientBranchIDs.clientBranchEditView]);

  useEffect(() => {
    if (state.ClientBranchIDs.clientBranchEditView != undefined) {
      const payload = {
        EditId: state.ClientBranchIDs.clientBranchEditView,
      };
      dispatch(setClientBranchesRetrieveActions(payload));
      // console.log(
      // state.BranchRetrieve.BranchesRetrieve,
      // "stae8080" ,

      // );
    }
    //console.log(state.BranchRetrieve.BranchesRetrieve, "wetgesdv");
  }, [state.ClientBranchIDs.clientBranchEditView]);

  //
  // useEffect(()=>{
  // if( state.BranchRetrieve.BranchesRetrieve != undefined &&
  // state.BranchRetrieve.BranchesRetrieve.zone_id.zone_name != undefined){
  // console.log(state.BranchRetrieve.BranchesRetrieve.zone_id.zone_name ,"XOness");
  // SETZONES(state.BranchRetrieve.BranchesRetrieve.zone_id.zone_name);
  // }
  // } ,[state.BranchRetrieve.BranchesRetrieve])

  // if (state.ClientBranchIDs.clientBranchEditView != undefined) {
  // if (state.BranchRetrieve.BranchesRetrieve.id) {
  // console.log(
  // state.BranchRetrieve.BranchesRetrieve.client_name,
  // "testingsss"
  // );
  // }
  // }
  function Counting(value) {
    setCount(value);
    return Counting;
  }
// console.log(state.clientDetailsCall.CreateActive ," state.clientDetailsCall.CreateActive");

  const HandleClicks = () => {
    if (state.clientDetailsCall.CreateActive == 1) {
      // console.log("Shift", Counts);
      ////---For-----The--Shifts
      setShiftCreatePopup(true);
      setEditID("");
    } else if (state.clientDetailsCall.CreateActive == 4) {
      setExcelSheetPo(true);
      /// console.log("Emp", Counts);
      // RouteHoldClient();
    } else if (state.clientDetailsCall.CreateActive == 5) {
      setSuperviorsState(true);
    } else {
    }
  };

  function capital_letter(str) {
    if (str !== undefined && str !== null) {
      str = str.split(" ");
  
      for (var i = 0; i < str.length; i++) {
        if (str[i]) {
          str[i] = str[i][0].toUpperCase() + str[i].substr(1);
        }
      }
  
      return str.join(" ");
    } else {
      return "--";
    }
  }


  // const handleFirstPageemp = () => {
  //   if (currentPageemp != 1) {
  //     const pageEntries = {
  //       search: searchemp,
  //       page_size: dtpagesizeEmp,
  //       page: 1,
  //       client_id: state.ClientBranchIDs.clientBranchEditView,
  //       old_employee: oldemplo.old_employee,
  //     };
  //     dispatch(SetVerifiedUserActions(pageEntries));
  //     setCurrentPageemp(1);
  //     setNewpageemp(1);
  //     setPageIndexDatEmp(1)

  //   }
  // };
  // const HandleLastPageemp = () => {
  //   if (
  //     currentPageemp !=
  //     Math.ceil(state.VerifiedUsers.Total_Count / dtpagesizeemp)
  //   ) {
  //     const pageEntries = {
  //       search: search,
  //       page_size: dtpagesize,
  //       page: Math.ceil(state.VerifiedUsers.Total_Count / dtpagesizeemp),
  //       client_id: state.ClientBranchIDs.clientBranchEditView,
  //       old_employee: oldemplo.old_employee,
  //     };
  //     dispatch(SetVerifiedUserActions(pageEntries));
  //     setNewpageemp(Math.ceil(state.VerifiedUsers.Total_Count / dtpagesizeemp));
  //     setCurrentPageemp(
  //       Math.ceil(state.VerifiedUsers.Total_Count / dtpagesizeemp)
  //     );
  //   }
  // };

  // const handleNextemp = (next) => {
  //   // console.log(
  //   // next,
  //   // "next one",
  //   // Math.ceil(state.VerifiedUsers.Total_Count / dtpagesizeemp)
  //   // );
  //   setPageIndexDatEmp(1)

  //   if (next != Math.ceil(state.VerifiedUsers.Total_Count / dtpagesizeemp)) {
  //     // if (next < state.VerifiedUsers.Total_Count){
  //     setCurrentPage(next + 1);
  //     // console.log(newpages, "newpagess");
  //     setNewpage(next + 1);
  //     const pageEntries = {
  //       search: search,
  //       page_size: dtpagesizeEmp,
  //       page: next + 1,
  //       client_id: state.ClientBranchIDs.clientBranchEditView,
  //       old_employee: oldemplo.old_employee,
  //     };
  //     dispatch(SetVerifiedUserActions(pageEntries));
  //     ///  console.log("New Page:", pageEntries);
  //   }
  // };

  // const handlePreviousemp = (previous) => {
  //   //  console.log(previous, "previous");
  //   if (previous != 0) {
  //     setPageIndexDatEmp(1)

  //     setCurrentPageemp(previous);
  //     const pageEntries = {
  //       search: search,
  //       page_size: dtpagesizeEmp,
  //       page: previous,
  //       client_id: state.ClientBranchIDs.clientBranchEditView,
  //       old_employee: oldemplo.old_employee,
  //     };
  //     dispatch(SetVerifiedUserActions(pageEntries));
  //   }
  // };

  // const payload = {
  //   search: searchemp,
  //   page_size: 10,
  //   page: 1,
  //   client_id: state.ClientBranchIDs.clientBranchEditView,
  //   //client_id: state.ClientBranchIDs.ClientBranchID,
  //   old_employee: e.value,
  // };
  // dispatch(SetVerifiedUserActions(payload));

  ////---Leave---Status----


  const [dtpageindexLevae, setdtPageindexLeave] = useState(
      TablePositionPersist?.Leave_empDatas?.page == undefined
        ? 1
        : TablePositionPersist.Leave_empDatas.page
    );
  const [dtpagesizeLeave, setdtPagesizeLeve] = useState(20);
  const [pageSizeLeave, setPageSizeLeave] = useState(10);
  const [newpagesLeave, setNewpageLeba] = useState(1);
   const [searchLeabe,setsearchLeave] = useState(
        TablePositionPersist?.Leave_empDatas?.search == undefined ||
        TablePositionPersist?.Leave_empDatas?.search == ""
          ? ''
          : TablePositionPersist?.Leave_empDatas?.search
      );  
  const [LeaveData, setLeavedatas] = useState([]);
  const [currentPageLeave, setCurrentPageLeave] = useState(1);

  useEffect(() => {
    if (state.clientDetailsCall.ActiveClinetTabs == 3) {
      const payload = {
        search:searchLeabe,
        // page_size: dtpagesizeLeave,
        page_size:20,

        page: dtpageindexLevae,
        client_id: state.ClientBranchIDs.clientBranchEditView,
        user: "",
      };
      dispatch(getLeaveStatusPersonsListed(payload));
                      dispatch(
                  setTablePositionPersist({ data: payload, pageName: "Leave_empDatas" })
                );
    }
  }, [state.clientDetailsCall.ActiveClinetTabs, dtpageindexLevae , searchLeabe]);

  const HandleDownloadLeaveStatus = (documents) => {
    window.open(documents);
  };
  ///-----__Leave----------Employees--------------

  const LeaveColumn = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.user_id.first_name}</span>
          </>
        );
      },
    },
    {
      Header: "From",
      accessor: "from_date",
    },
    {
      Header: "To",
      accessor: "to_date",
    },
    {
      Header: "Note",
      accessor: "notes",
    },
    ///------Leave---document-----uploads
    {
      Header: "Reason",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="LeaveStatusBtn">
              {row.row.original.leave_type != null &&
              row.row.original.leave_type.leave_type != undefined ? (
                <span>{row.row.original.leave_type.leave_type}</span>
              ) : (
                <span>{"---"}</span>
              )}

              {row.row.original.certificate_id != undefined &&
              row.row.original.certificate_id.media_url != undefined ? (
                <button
                  type="button"
                  class="btn "
                  onClick={(e) => {
                    HandleDownloadLeaveStatus(
                      row.row.original.certificate_id.media_url
                    );
                  }}
                >
                  <img src={downloadoffer} alt="Download Offer Letter" />
                  </button>
              ) : (
                <span>{""}</span>
              )}
            </div>
          </>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
  ];

  const debouncedLeave = useMemo(
    () =>
      _.debounce((e) => {
            setsearchLeave(e);

      }, 500),
    []
  );

  function tochangeLeave(e) {
    // console.log("ee", e);
    setdtPageindexLeave(1)
    debouncedLeave(e);
    // if (e.trim() != undefined && e.trim() !== "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesizeLeave,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     user: "",
    //   };
    //   dispatch(getLeaveStatusPersonsListed(payload));
    // }
    // if (e == "" || searchemp == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesizeLeave,
    //     page: 1,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     user: "",
    //   };
    //   dispatch(getLeaveStatusPersonsListed(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedLeave.cancel();
    };
  }, [debouncedLeave]);
console.log(state.ClientBranchIDs.Branch_view_details ,"sdiufpsudf ClientBranchIDs");

  const handlePageLeaveChange = (newPage) => {
    if (newPage < state.ShiftList.Total_Count) {
      setCurrentPage(newpages + 1);
      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        page_size: 20,
        page: newPage,
        client_id: state.ClientBranchIDs.clientBranchEditView,
        user: "",
      };
      // dispatch(SetShiftSearchActions(pageEntries));
      dispatch(getLeaveStatusPersonsListed(pageEntries));
    }
  };

  const handleNextLeave = (next) => {
    
    setdtPageindexLeave(next + 1);

    
  };

  const handlePreviousLeave = (previous) => {
      setdtPageindexLeave(previous);

  };


  const GotoPageEnteredLeave = (previous) => {
    setdtPageindexLeave(previous);

};

 

  
  const pagesizeLevae = (arg) => {
    setdtPagesizeLeve(arg);
  };
  const pageindexLeave = (arg) => {
    //  console.log(arg, "args");
    setdtPageindexLeave(arg);
  };

  /////-----------------___Excel---Sheet----Uploads---Get--LIST-----------------
  const [dtpageindexExcel, setdtPageindexexcel] = useState(1);
  const [dtpagesizeecel, setdtPagesizeexcel] = useState(10);
  const [pageSizeexcel, setPageSizexcel] = useState(20);
  const [newpagesexcel, setNewpageexcel] = useState(1);


  const [searchexcel,setsearchexcel] = useState(
        TablePositionPersist?.ShiftUpload_empDatas?.search == undefined ||
        TablePositionPersist?.ShiftUpload_empDatas?.search == ""
          ? ''
          : TablePositionPersist?.ShiftUpload_empDatas?.search
      );  


      
  const [currentPageEXcel, setCurrentPageExcel] = useState(
      TablePositionPersist?.ShiftUpload_empDatas?.page == undefined
        ? 1
        : TablePositionPersist.ShiftUpload_empDatas.page
    );
  ///----Shift-------Upload----get------------------
  useEffect(() => {
     console.log(state.clientDetailsCall.ActiveClinetTabs ,"owieActiveClinetTabs" );
     
    if (state.clientDetailsCall.ActiveClinetTabs == 4) {
      const payload = {
        search: searchexcel,
        // page_size: 10,
        page_size: 20,

        page:currentPageEXcel,
        client: state.ClientBranchIDs.clientBranchEditView,
        user: "",
        month:filters?.month,
        year:filters?.year,
      };
      dispatch(getShiftStatusPersonsListed(payload));
                            dispatch(
                  setTablePositionPersist({ data: payload, pageName: "ShiftUpload_empDatas" })
                );
      // console.log(state.ShfitData.Shiftdatas, "dauysfda Total_Count");
    }
  }, [state.clientDetailsCall.ActiveClinetTabs , currentPageEXcel ,filters ,searchexcel]);
  
  useEffect(()=>{
     dispatch(settheStore_filter_monthand_yeas(filters))
  },[filters])
  const handlePreviousExcelSheet = (previous) => {
      setCurrentPageExcel(previous);
  };
  const handleNextexcelsheet = (next) => {
      setCurrentPageExcel(next + 1);
  };
   const GotoEnteredPageExcelPage=(page)=>{
    setCurrentPageExcel(page);

   }
  const pagesizeexcel = (arg) => {
    setdtPagesizeexcel(arg);
  };
  const pageindexexcel = (arg) => {
    setdtPageindexexcel(arg);
  };

  const debouncedSheetupload = useMemo(
    () =>
      _.debounce((e) => {
       setsearchexcel(e)
      }, 500),
    []
  );

  // -----Search------------------------
  function tochangeshiftExcel(e) {
   setCurrentPageExcel(1)
    debouncedSheetupload(e);
    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesizeecel,
    //     page: 1,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     user: "",
    //   };
    //   // console.log(e, "testnew")
    //   dispatch(getShiftStatusPersonsListed(payload));
    // }
    // if (e == "" || searchexcel == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesizeecel,
    //     page: 1,
    //     client_id: state.ClientBranchIDs.clientBranchEditView,
    //     user: "",
    //   };
    //   dispatch(getShiftStatusPersonsListed(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedSheetupload.cancel();
    };
  }, [debouncedSheetupload]);

  const columnShift = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.month ? (
              <spn>{row.row.original.month}</spn>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Year",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.year ? (
              <spn>{row.row.original.year}</spn>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month Start",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.month_start;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;
        return (
          <>
            {row.row.original.month_start ? (
              <span>{`${
                row.row.original.month_start.slice(0, 10) + "  " + formattedTime
              }`}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month End",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.month_end;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedTime = `${twelveHourFormat}:${minutes} ${amOrPm}`;
        return (
          <>
            {row.row.original.month_end ? (
              <span>{`${
                row.row.original.month_end.slice(0, 10) + "  " + formattedTime
              }`}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Leave Counts",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.leave_count ? (
              <span>{row.row.original.leave_count}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
  ];

  const handleCalenders = (e) => {
    /// console.log(e.id ,"IDS" , e.user_id.id    );
    dispatch(setTheShiftExcelSheetIDS(e));

    if (state.ClientBranchIDs.ShiftExcelsheetID?.id == e.id) {
      navigate("/calender");
    }
  };

  const attendanceexport = (e, statement, values) => {
    console.log(values, statement, e, "auysfdyasdlas");
    Swal.fire({
      title: `Are you sure, do you want to export the attendance  ${
        statement ? "based on this month to end of the  month" : ""
      }?`,
      text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#234492",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Export it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const payloads = {
          export_type: values,
          client_id: state.ClientBranchIDs.clientBranchEditView,
          user_id: "",
          data: data,
        };
        dispatch(StetheAttendanceExportActions(payloads));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };

  console.log(state.NeededdatasListed.BranchNameListed, "BranchNameListed");
  const [TabNmaes, setTabnames] = useState({ clientname: "", branchname: "" });
  useEffect(() => {
    if (
      state.NeededdatasListed.clientNameList &&
      typeof state.NeededdatasListed.clientNameList === "string"
    ) {
      const maxLength = 10; // Set your desired maximum length
      const ellipsis = "..."; // Set your ellipsis string

      const truncatedClientName =
        state.NeededdatasListed.clientNameList.length > maxLength
          ? `${state.NeededdatasListed.clientNameList.substring(
              0,
              maxLength
            )}${ellipsis}`
          : state.NeededdatasListed.clientNameList;
      console.log("Truncated Client Name:", truncatedClientName);

      const truncatedBranchNameName =
        state.NeededdatasListed.BranchNameListed.length > maxLength
          ? `${state.NeededdatasListed.BranchNameListed.substring(
              0,
              maxLength
            )}${ellipsis}`
          : state.NeededdatasListed.BranchNameListed;

      setTabnames({
        ...TabNmaes,
        clientname: truncatedClientName,
        branchname: truncatedBranchNameName,
      });
      // Use `truncatedClientName` in your component
      console.log("Truncated Client Name:", truncatedClientName);
    } else {
      // Handle the case when clientNameList is undefined or not a string
      console.log("Client Name List is undefined or not a string");
    }
  }, [state.NeededdatasListed]);

  
  return (
    <>
      <div className="Details">
        <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
          <div className="Header-Details ClientBranch row">
            <div
              // className="InnerUsers"
              class="col-sm-7 auto"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <h3 >Profile</h3>

              {/* <ul class="breadcrumb">
                <li
                  class="breadcrumb-item"
                  data-tooltip-id="Name-ToolTips"
                  data-tooltip-content={
                    state.NeededdatasListed.clientNameList != ""
                      ? state.NeededdatasListed.clientNameList
                      : ""
                  }
                >
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/client"}
                    onClick={(e) => {
                      dispatch(getSideBarfilesActions("Client"));
                    }}
                  >

                    {TabNmaes.clientname}
                  </NavLink>
                </li>
                <li
                  class="breadcrumb-item"
                  data-tooltip-id="Name-ToolTips"
                  data-tooltip-content={
                    state.NeededdatasListed.BranchNameListed != ""
                      ? state.NeededdatasListed.BranchNameListed
                      : ""
                  }
                >
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/clientbranch"}
                    onClick={(e) => {
                      dispatch(getSideBarfilesActions("Client"));
                    }}
                  >
                 
                    {TabNmaes.branchname}
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">
                  Profile
                </li>
              </ul> */}
            </div>

            <div
              className={`Add-User col-sm-5 clientdetails ${
                Counts == 2 ? "hidden" : "DisplayCreate"
              }`}

              style={{ display: "flex", gap: "30px" }}
            >
              {state.clientDetailsCall.ActiveClinetTabs == 4 ? (
                <button onClick={(e) => handleDownload()} className="ButtonCSS">
                  Sample Sheet
                </button>
              ) : null}

{state.clientDetailsCall.CreateActive == 1 ? 
// state?.SideBarFiles?.UserEmailID == "admin@gmail.com" || state?.SideBarFiles?.UserEmailID == "admin@qpms.in" 
state.ClientBranchIDs.SUBROLE == 3
?

              <button
                className={` ButtonCSS ${
                  state.clientDetailsCall.CreateActive == 2
                    ? "hidden"
                    : 
                    "DisplayCreate"
                }`}
                onClick={(e) => {
                  if (state.clientDetailsCall.CreateActive != 2) {
                    HandleClicks();
                  }
                }}
              >
                {/* {Counts == 5
                  ? "Create Supervisor"
                  : Counts == 4
                  ? "Upload Sheet"
                  : "Create Shift"} */}

                {state.clientDetailsCall.CreateActive == 5
                  ? "Create Supervisor"
                  : state.clientDetailsCall.CreateActive == 4
                  ? "Upload Sheet"
                  :  "Create Shift"}

                {/* { Counts == 4
                  ? "Upload Sheet"
                  : "Create Shift"} */}
              </button>
: null :
              <button
                className={` ButtonCSS ${
                  state.clientDetailsCall.CreateActive == 2
                    ? "hidden"
                    : 
                    "DisplayCreate"
                }`}
                onClick={(e) => {
                  if (state.clientDetailsCall.CreateActive != 2) {
                    HandleClicks();
                  }
                }}
              >
                {/* {Counts == 5
                  ? "Create Supervisor"
                  : Counts == 4
                  ? "Upload Sheet"
                  : "Create Shift"} */}

                {state.clientDetailsCall.CreateActive == 5
                  ? "Create Supervisor"
                  : state.clientDetailsCall.CreateActive == 4
                  ? "Upload Sheet"
                  :  "Create Shift"}

                {/* { Counts == 4
                  ? "Upload Sheet"
                  : "Create Shift"} */}
              </button>
}
            </div>
          </div>

          <div
            className="row Filters ButtonPrevious"
            // style={{
            //   padding: "15px 28px",
            //   margin: "0px",
            //   position: "relative",
            //   zIndex: "30",
            //      

            //   marginLeft: "0px",
            //   marginRight: "0px",
            //   top: "-30px",
            // }}
            style={{ marginLeft: "-17px" }}
          >
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/clientbranch");
                }}
              >
                  <img  className="PreviousPages" src={BackImage}/>
                  <span></span>
              </button>
            </div>
          </div>

          <div className="row ProfileFile">
            <div className="col-md-12" style={{paddingBottom:"25px"}}>
              <div className="row">
                {/* <div className="ListedLinks">
                    <ul>
                      <li>
                       <a href={state.ClientBranchIDs.NavigateCAll}>{state.ClientBranchIDs.NavigateCAll}  </a>
                        </li>
                        {/* <li>
                       <a href={state.SideBarFiles.SideBarFile}>{state.SideBarFiles.SideBarFile} </a>
                        </li> */}
                {/* </ul>
                    </div> */}
              </div>
              <div class="profile-header">
                <div
                  class="row  align-items-center"
                  style={{ padding: "23px" }}
                >
                  <div class="col-auto ">
                    <a>
                      <div className="BranchLogo">
                        <img class="" alt="User Image" src={profile2} />
                      </div>
                    </a>
                  </div>
                  <div class="col ml-md-n2 profile-user-info">
                  {state.BranchRetrieve.BranchesRetrieve != undefined && state.BranchRetrieve.BranchesRetrieve?.client_name !=
                    undefined ? (
                      <h4
                        class="user-name mb-0"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          gap: "10px",
                          fontWeight: "700",
                           fontSize:"14px",
                        }}
                      >
                        {/* {state.BranchRetrieve.BranchesRetrieve.client_name.toUpperCase()} */}
                        {
                        state.BranchRetrieve.BranchesRetrieve != undefined &&
                        state.BranchRetrieve.BranchesRetrieve !=null ?
                        capital_letter(
                          state.BranchRetrieve.BranchesRetrieve?.client_name
                        )
                      :"--"}
                      
{/* 
                       <span
                          style={{
                            background: "rgb(255 217 217)",
                            color: "#F57F38",
                            padding: "7px",
                            borderRadius: "13px",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setidforuploaddata({
                              ...getidforupload,
                              user_id: "",
                              client_id:
                                state.ClientBranchIDs.clientBranchEditView,
                            });
                            setExcelSheetFORKYCPopup(true);
                          }}
                          className="OuterExcelSheet"
                        >
                          {" "}
                          <i class="fa-solid fa-sheet-plastic"></i>
                          <span
                            style={{
                              color: "#F57F38",
                              marginLeft: "5px",
                              fontSize: "19px",
                              padding: "6px",
                            }}
                            className="excelsheetdisplay"
                          >
                            Excel sheet
                          </span>
                        </span> */}


                      </h4>
                    ) : null}
                    {state.BranchRetrieve.BranchesRetrieve != undefined &&
                    state.BranchRetrieve.BranchesRetrieve.zone_id !=
                      undefined &&
                    state.BranchRetrieve.BranchesRetrieve.zone_id != null ? (
                      <p
                        className="superViorName"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "20px",
                          color: "#234492",
                          fontSize: "14px",
                          // marginTop: "12px",
                        }}
                      >
                        {
                          state.BranchRetrieve.BranchesRetrieve.zone_id
                            .zone_name
                        }

                        {/* <button
                          style={{
                            background: "rgb(255 217 217)",
                            color: "#F57F38",
                            padding: "0px",
                            borderRadius: "13px",
                            fontSize: "18px",
                            cursor: "pointer",
                            //  width:"300px"
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",

                            // padding: "5px",
                            padding: "5px 5px",

                            marginTop: "8px",
                          }}
                          onClick={(e) => {
                            setSuperviorsState(true);
                          }}
                        >

                          <AddModeratorIcon />
                          <span>Supervisor</span>
                        </button> */}
                      </p>
                    ) : null}
                  </div>

                  {/*                   
                  <div
                    class="col-auto profile-btn col-6"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >

                    <div
                      className="DatePicker daterangeinclientdetails"
                      style={{ width: "80%" }}
                    >
                      <select
                        style={{
                          width: "100%",
                          padding: "10px",
                          marginTop: "10px",
                        }}
                        class="form-select form-select-lg mb-3"
                        aria-label=".form-select-lg example"
                        name="marital_status"
                        readOnly={
                          state.NumberCounts.Editable == 1 ? true : false
                        }
                        onChange={(e) => {
                          HandleChanges(e);
                        }}
                      >
                        {Options.map((item) => (
                          <option
                            value={item.value}
                          >
                            {item.label}
                          </option>
                        ))}
                      </select>

                    

                      <DateRangePicker
                        className="Dateranger"
                        style={{ width: "100%", padding: 10 }}
                        placeholder="Form-To"
                        onChange={handleDateChange}
                        showHeader={false}
                        size="lg"
                        value={selectedDates}
                      />
                    </div>

                    <button
                      style={{
                        borderRadius: "7px",
                        height: "47px",
                        marginTop: "8px",
                        width: "24%",
                      }}
                      class="  editview "
                      onClick={(e) => {
                        e.stopPropagation();

                        if (
                          startDatemon == data.from_date &&
                          endDatemon == data.to_date
                        ) {
                          attendanceexport(e, true, "client");
                        } else {
                          attendanceexport(e, false, "client");
                        }
                      }}
                    >
                      {" "}
                      Attendance Export
                    </button>
                  </div> */}

                  <div class="col-auto profile-btn">
                    {/* <button
                      class=" editview ButtonCSS"
                      onClick={(e) => {
                        dispatch(Branch_EDIT_CLIENT_DETAILS(2)); ///--For----close the--client-----details--
                        e.stopPropagation();
                        setEditPopupBranch(true);
                      }}
                    >
                      Edit
                    </button> */}

                    {/* <button
                      class=" editview ButtonCSS"
                       style={{ display:"flex", }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setidforuploaddata({
                          ...getidforupload,
                          user_id: "",
                          client_id: state.ClientBranchIDs.clientBranchEditView,
                        });
                        setExcelSheetFORKYCPopup(true);
                      }}
                    >
                      <i class="fa-solid fa-sheet-plastic"  style={{ marginLeft:"-25px"}}></i>
                    Excel sheet
                    </button> */}

                    <button
                      class="btn "
                      style={{ background: "#234492", color: "white",display:"flex",gap:"2px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setidforuploaddata({
                          ...getidforupload,
                          user_id: "",
                          client_id: state.ClientBranchIDs.clientBranchEditView,
                        });
                        setExcelSheetFORKYCPopup(true);
                      }}
                    >
                      <span className="ExcelSheetImages">
                        <img src={ExcelSheetImage}/>
                      </span>
                      Excel Sheet
                    </button>
                  </div>
                </div>

                <div className="profile-menu TabsStartHead">
                  <div className="innerTabs">
                    <ul class="nav nav-tabs" id="ex1" role="tablist">
                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          // class=" active"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 1
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-1"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-1"
                          role="tab"
                          aria-controls="ex3-tabs-1"
                          aria-selected="true"
                          onClick={(e) => {
                            Counting(1);
                            dispatch(setCreateActive(1));

                            dispatch(SettheActiveTabsActionClientDetails(1));
                          }}
                        >
                          Shift
                        </button>
                      </li>

                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          //  class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 2
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-2"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(2);
                            dispatch(setCreateActive(2));

                            dispatch(SettheActiveTabsActionClientDetails(2));
                          }}
                        >
                          Employee
                        </button>
                      </li>

                      {state.ClientBranchIDs.Branch_view_details?.has_leave == true && (
                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          /// class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 3
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#leave"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(2);
                            dispatch(setCreateActive(2));

                            dispatch(SettheActiveTabsActionClientDetails(3));
                          }}
                          //style={{ display: "none" }}
                        >
                          Leave status
                        </button>
                      </li>
                        )}


                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          // class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 4
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#shiftExcel"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(4);
                            dispatch(setCreateActive(4));

                            dispatch(SettheActiveTabsActionClientDetails(4));
                          }}
                          //style={{ display: "none" }}
                        >
                          Shift Upload
                        </button>
                      </li>
                      <li class="nav-item TABHEADER" role="presentation">
                        <button
                          // class="nav-link"
                          className={`  nav-link   ${
                            state.clientDetailsCall.ActiveClinetTabs == 5
                              ? "active "
                              : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#Superviors"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          onClick={(e) => {
                            Counting(5);
                            dispatch(setCreateActive(5));
                            dispatch(SettheActiveTabsActionClientDetails(5));
                          }}
                          //style={{ display: "none" }}
                        >
                          Supervisor
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="card BeforeTabs ">
                <div className="card-body innerBody">
                  <div className="TabsStart">
                    <div className="row">
                      <div className="col-12">
                        <div className="card">
                          <div className="card-body DetailsPart">
                            {/* <ul class="nav justify-content-center">
                      <li class="nav-item">
                        <a class="nav-link active" aria-current="page" href="#">
                         Shift
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" href="#">
                        Emp Inquiry
                        </a>
                      </li>
                    </ul> */}

                            <div class="tab-content" id="ex2-content">
                              <div
                                // class=`tab-pane fade show active ``
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall.ActiveClinetTabs == 1
                                    ? "active "
                                    : ""
                                }`}
                                id="ex3-tabs-1"
                                role="tabpanel"
                                aria-labelledby="ex3-tab-1"
                              >
                                {/* <div className="InnerUsers">
                              <h3>Shift</h3>
                            </div> */}
                                {/* ////-------------Shift---Branch--Search---- */}
                                {/* <div
                          className="row ShiftSelects"
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            marginRight: "20px",
                          }}
                        >
                          <div className="col-4 mt-3">
                            <label
                              for="validationCustom01"
                              class="form-label"
                              style={{ fontFamily: "Mediumweight" }}
                            >
                              Client Branch Name
                            </label>
                            <Select
                              className="Selects"
                              styles={{ position: "relative", top: "60px" }}
                              // options={options}
                              // onChange={handleChange}
                              onSelect={(e) => setMUltiselectBranch(e)}
                              onRemove={(e) => setMUltiselectBranch(e)}
                              onChange={(e) => {
                                handleBranchNames(e);
                              }}
                              options={branchName}
                              labelledBy="Select"
                            />
                          </div>
                        </div> */}

                                {/* ////------------------SHift------Tables---------------- */}
                                {dataShift != undefined ? (
                                  <div style={{ padding: "0px" }}>
                                    <ReactTable
                                      style={{ zIndex: "142 !important" }}
                                      /// data={state.ShiftList.ShiftLists}
                                      data={state.ShiftSearch.ShiftSearch}
                                      columns={columns}
                                      // totalItems={state.ShiftList.Total_Count}
                                      totalItems={state.ShiftSearch.Total_Count}
                                      currentPage={currentPageShift}
                                      // onPageChange={handlePageChange}
                                      onChange={tochange}
                                      setCurrentPage={setCurrentPage}
                                      pagesize={pagesize}
                                      onPrevious={handlePrevious}
                                      onNextpage={handleNext}
                                      GotoEnteredPage={GotoEnteredPage}
                                      dtpagesize={pageSize}
                                      dtpageindex={currentPageShift}
                                      pageindex={pageindex}
                                      // datacount={state.ShiftList.Total_Count}
                                      datacount={state.ShiftSearch.Total_Count}

                                      Oncreate={(e) => {
                                        // window.location.href = "/shiftCreate";
                                        setShiftCreatePopup(true);
                                        setEditID("");
                                      }}

                                      Filter={true}
                                      NoFilter ={true}
        searchVal={TablePositionPersist?.Shift_empDatas?.search == "" || TablePositionPersist?.Shift_empDatas?.search ==undefined? "":TablePositionPersist.Shift_empDatas.search}
              search_key={true}

                                      
                                    />
                                  </div>
                                ) : null}


                              </div>

                              {/* ////-------------EMP---INQURIY----------------- */}
                              <div
                                //  class="tab-pane fade"
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall.ActiveClinetTabs == 2
                                    ? "active "
                                    : ""
                                }`}
                                id="ex3-tabs-2"
                                role="tabpanel"
                                aria-labelledby="ex3-tab-2"
                              >
                                <ApproveEmployee />

                                {/* <div className="InnerUsers">
                              <h3>Employee</h3>
                            </div> */}
                                {/* ///----Emp-----Tables---------- */}
                                {/*  */}
                                {/* {EmpDAta != undefined ? ( */}
                                {/* // <div style={{ padding: "0px" }}> */}
                                {/* <ReactTable */}
                                {/* // data={ */}
                                {/* // state.EmployeeListsdata.EmployeeLists */}
                                {/* // } */}
                                {/* // columns={columnsEMp} */}
                                {/* // totalItems={ */}
                                {/* // state.EmployeeListsdata.Total_Count */}
                                {/* // } */}
                                {/* // currentPage={currentPageEmp} */}
                                {/* // onChange={toEmpSearch} */}
                                {/* // setCurrentPage={setcurrentPageemp} */}
                                {/* // pagesize={pagesizeEMP} */}
                                {/* // onPrevious={handlePreviousEmp} */}
                                {/* // onNextpage={handleNextEmp} */}
                                {/* // dtpagesize={pageSizeEMP} */}
                                {/* // dtpageindex={currentPageEmp} */}
                                {/* // pageindex={pageindexEMP} */}
                                {/* // datacount={ */}
                                {/* // state.EmployeeListsdata.Total_Count */}
                                {/* // } */}
                                {/* // onPageChange={handlePageChangeEMP} */}
                                {/* // onFirstPage={handleFirstPageEMP} */}
                                {/* // OnhandleLastpgae={HandleLastPageEMP} */}
                                {/* // Oncreate={(e) => {}} */}
                                {/* // /> */}
                                {/* </div> */}
                                {/* // ) : null} */}
                                {/*  */}
                                {/* ////-----DELETE--------------------------- */}
                                {/* {DeleteEmpPOPUP && */}
                                {/* // state.ClientBranchIDs.clientBranchEditView != */}
                                {/* // undefined ? ( */}
                                {/* // <Delete */}
                                {/* // show={DeleteEmpPOPUP} */}
                                {/* // setShow={setDeletePOPUPEMp} */}
                                {/* // onSubmit={HandleEmpDelete} */}
                                {/* // client_id={ */}
                                {/* // state.ClientBranchIDs.clientBranchEditView */}
                                {/* // } */}
                                {/* // /> */}
                                {/* // ) : null} */}
                                {/* //////--------------Branch---_Edit------------------ */}
                                {/* -------------------EDITPOPUP----------------- */}
                                {/* {EditPopupEmp && currentPageEmp != undefined && EditId != undefined ? (
                              <EmployeeCreate
                                EditId={state.ClientBranchIDs.EmployeeIDs}
                                currentPage={currentPageEmp}
                                client_id={EditId}
                                setShow={setsetEditEmpPOPUP}
                              />
                            ) : null} */}
                                {/* {EmpCreatepopup  && currentPageEmp != undefined && EditId != undefined ?
                              <EmployeeCreate 
                              currentPage={currentPageEmp}  
                              client_id={EditId}
                              setShow={setCreateEmpPopup} />
                              :
                              null
                          } */}
                              </div>

                              {/* -------------------Leave------------Status---------------- */}
                              <div
                                //   class="tab-pane fade "
                                className={`  tab-pane fade show   ${
                                  state.clientDetailsCall.ActiveClinetTabs == 3
                                    ? "active "
                                    : ""
                                }`}
                                id="leave"
                                role="tabpanel"
                                aria-labelledby="ex3-tab-1"
                                //style={{ display: "none" }}
                              >
                                <ReactTable
                                  data={state.LeaveStatusListed.LeaveStatusLis}
                                  columns={LeaveColumn}
                                  totalItems={
                                    state.LeaveStatusListed.Total_Count
                                  }
                                  currentPage={currentPageLeave}
                                  onChange={tochangeLeave}
                                  setCurrentPage={setCurrentPageLeave}
                                  pagesize={pagesizeLevae}
                                  onPrevious={handlePreviousLeave}
                                  onNextpage={handleNextLeave}
                                  GotoEnteredPage={GotoPageEnteredLeave}
                                  dtpagesize={dtpagesizeLeave}
                                  dtpageindex={dtpageindexLevae}
                                  pageindex={pageindexLeave}
                                  datacount={
                                    state.LeaveStatusListed.Total_Count
                                  }
                                  

          searchVal={TablePositionPersist?.Leave_empDatas?.search == "" || TablePositionPersist?.Leave_empDatas?.search ==undefined? "":TablePositionPersist.Leave_empDatas.search}
              search_key={true}
                                  Filter={true}
                                  NoFilter ={true}
                                  
                                />
                              </div>
                              {/* -------------------Shift---Exce;------------Status---------------- */}
                              <div
                                //  class="tab-pane fade  "

                                className={`  tab-pane fade show  ExcelSheetGetList ${
                                  state.clientDetailsCall.ActiveClinetTabs == 4
                                    ? "active "
                                    : ""
                                }`}
                                id="shiftExcel"
                                // /style={{ display: "none" }}
                                role="tabpanel"
                                aria-labelledby="ex3-tab-2"
                              >
                                <div style={{ padding: "0px" }}>
                                  <ReactTable
                                    data={state.ShfitData.Shiftdatas}
                                    columns={columnShift}
                                    totalItems={state.ShfitData.Total_Count}
                                    currentPage={currentPageEXcel}
                                    onChange={tochangeshiftExcel}
                                    setCurrentPage={setCurrentPageExcel}
                                    pagesize={pagesizeexcel}
                                    onPrevious={handlePreviousExcelSheet}
                                    onNextpage={handleNextexcelsheet}
                                    GotoEnteredPage={GotoEnteredPageExcelPage}
                                    dtpagesize={pageSizeexcel}
                                    dtpageindex={currentPageEXcel}
                                    pageindex={pageindexexcel}
                                    datacount={state.ShfitData.Total_Count}
                                    MakeCreate={true}
                                    ViewParts={(e) => {
                                      handleCalenders(e);
                                    }}
                                    Filter={true}
                                    NoFilter ={false}
                                    Month_date_pick={true}
                                    nostatusFilter={true}
                                    value_of_monthDate={filters}
onChange_ofMonthDate={setFilters}  
searchVal={TablePositionPersist?.ShiftUpload_empDatas?.search == "" || TablePositionPersist?.ShiftUpload_empDatas?.search ==undefined? "":TablePositionPersist.ShiftUpload_empDatas.search}
              search_key={true}
                                  />
                                </div>
                              </div>

                              {/* -------------------------------------Supervor------------- */}
                              <div class="tab-content" id="ex2-content">
                                <div
                                  // class=`tab-pane fade show active ``
                                  className={`  tab-pane fade show   ${
                                    state.clientDetailsCall.ActiveClinetTabs ==
                                    5
                                      ? "active "
                                      : ""
                                  }`}
                                  id="ex3-tabs-1"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tab-1"
                                >
                                  <div className="" style={{ padding: "0px" }}>
                                    {/* <div className="row SupervisorCreateInsideTable">
                                      <div className="col-6">
                                        <button
                                          style={{
                                            background: "rgb(255 217 217)",
                                            color: "#F57F38",
                                            // padding: "0px",
                                            // borderRadius: "13px",
                                            // fontSize: "18px",
                                            // cursor: "pointer",
                                            // //  width:"300px"
                                            // display: "flex",
                                            // flexDirection: "row",
                                            // alignItems: "center",

                                            // // padding: "5px",
                                            // padding: "5px 5px",

                                            // marginTop: "8px",
                                          }}
                                          className="ButtonCSS"
                                          onClick={(e) => {
                                            setSuperviorsState(true);
                                          }}
                                        >
                                          <span>
                                            {" "}
                                            <AddModeratorIcon /> Create
                                            Supervisor
                                          </span>
                                        </button>
                                      </div>
                                    </div> */}

                                    <ReactTable
                                      data={
                                        state.SuperviorsSlice.SuperviorsData
                                      }
                                      columns={columnSuperviorss}
                                      totalItems={
                                        state.SuperviorsSlice.Total_Count
                                      }
                                      currentPage={currentPageSuperviorsSlice}
                                      // onPageChange={handlePageChange}
                                      onChange={tochangeSuperviorsSlice}
                                      setCurrentPage={
                                        setCurrentPageSuperviorsSlice
                                      }
                                      pagesize={pageSuperviorsSlicesize}
                                      onPrevious={handleSuperviorsSlicePrevious}
                                      onNextpage={handleSuperviorsSliceNext}
                                      dtpagesize={dtpagesizeSuperviorsSlice}
                                      GotoEnteredPage={GotoEnteredPageSupervisor}
                                      dtpageindex={currentPageSuperviorsSlice}
                                      pageindex={pageSuperviorsSliceindex}
                                      datacount={
                                        state.SuperviorsSlice.Total_Count
                                      }
                                      setsno={setsno}
                                      sno={sno}
                                      id={"spe"}
                                      // Filter={true}
                                      // MakeCreate={false}
                                      // Superviorsfilter={true}
                                      // supervisoreOptions={supervisoreOptions}
                                      // TypeOfsuperviors={TypeOfsuperviors}
                                      // superviorChanges={superviorChanges}

                                      // Filter={false}
                                      MakeCreate={false}

                                      Filter={true}
                                      NoFilter ={true}
                                       searchVal={TablePositionPersist?.Supervisor_empDatas?.search == "" || TablePositionPersist?.Supervisor_empDatas?.search ==undefined? "":TablePositionPersist.Supervisor_empDatas.search}
              search_key={true}

                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {EditBranchPOPUP && BranchEditid != "" ? (
        <ClientBranchCreate
          show={state.ClientBranchIDs.ClientEditFunctions}
          setShow={setEditPopupBranch}
          currentPage={1}
          EditId={BranchEditid}
        />
      ) : null}
      {state.ClientBranchIDs.clientBranchEditView != undefined &&
      ExcelSheetpop ? (
        <ExcelSheetUpload
          show={ExcelSheetpop}
          setShow={setExcelSheetPo}
          branchId={state.ClientBranchIDs.clientBranchEditView}
          page={currentPageEXcel}
          filters={filters}
        />
      ) : null}

      {/* ---------------------___Site-------------------_Transfer------------------- */}

      <>
        {createpoup ? (
          <SiteCreateEdit
            show={createpoup}
            setShow={setcreatepoup}
            currentPage={newpages}
            EditId={EmployeeIDs}
            selectVal={""}
            datas={""}
          />
        ) : null}
      </>

      {/* ----Black----list---------------------------------- */}
      {createblack ? (
        <BlackListCeatePoup
          show={createblack}
          setShow={setcreatepoupblack}
          ActiveFor={1}
          currentPage={newpages}
          EditId={EmployeeIDsblacklist}
          selectVal={""}
          datas={""}
        />
      ) : null}

      <>
        {/* <Tooltip id="Name-ToolTips" zIndex={999} /> */}
      </>

      <>
        {ExcelSheeTFORKYCPopup ? (
          <ExcelFormatDwonload
            show={ExcelSheeTFORKYCPopup}
            setShow={setExcelSheetFORKYCPopup}
            EditID={getidforupload}
          />
        ) : null}
      </>

      <>
        {InActiveCreatePop &&
        InActiveCreateId != "" &&
        InActiveCreateId != undefined ? (
          <ActiveEmployeeCreate
            show={InActiveCreatePop}
            setShow={setInActiveCreatePoup}
            UserID={InActiveCreateId}
          />
        ) : null}
      </>
      <>
        {SuperviorsState ? (
          <Superviors
            show={SuperviorsState}
            setShow={setSuperviorsState}
            client_id={state.ClientBranchIDs.clientBranchEditView}
            old_employee={oldemplo.old_employee}
            page={dtpageindexSuperviorsSlice}
            search={searchSuperviorsSlice}
          />
        ) : null}
      </>

      <>
      {/* ------Shift--create--edit----- */}
      {EditPopup &&
                                state.ClientBranchIDs.clientBranchEditView !=
                                  "" &&
                                currentPageShift != undefined ? (
                                  <ShiftCreateForm
                                    EditId={EditIDSHIFT}
                                    client_id={
                                      state.ClientBranchIDs.clientBranchEditView
                                    }
                                    currentPageShift={currentPageShift}
                                    setShow={setEditpopup}
                                  />
                                ) : null}
                                {ShiftCreatePOPup &&
                                state.ClientBranchIDs.clientBranchEditView !=
                                  "" &&
                                currentPageShift != undefined ? (
                                  <ShiftCreateForm
                                    client_id={
                                      state.ClientBranchIDs.clientBranchEditView
                                    }
                                    setShow={setShiftCreatePopup}
                                    currentPageShift={currentPageShift}
                                  />
                                ) : null}

                                {DeletePOPUP ? (
                                  <Delete
                                    show={DeletePOPUP}
                                    setShow={setDeletePOPUP}
                                    onSubmit={HandelDelete}
                                    Content={"Do you want to delete the Shift"}
                                  />
                                ) : null}
      
      </>
    </>
  );
};

export default ClientDetails;
